import React from 'react';
import { IAddress } from '../../../../generated/graphql';
import DialogBox from '../../../Common/Layout/DialogBox';
import AddressForm from './AddressForm';

interface IProps {
  handleClose: () => void;
  updateList: (address: IAddress) => void;
  companyId: number;
}

const NewAddress: React.FunctionComponent<IProps> = ({
  handleClose,
  updateList,
  companyId
}: IProps) => {
  return (
    <DialogBox id="alert" width={1400} title="New Address" onClose={handleClose}>
      <AddressForm handleClose={handleClose} updateList={updateList} companyId={companyId} />
    </DialogBox>
  );
};

export default NewAddress;
